var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.flag)?_vm._t("default"):_c('h6',[_c('span',{staticClass:"badge badge-soft-dark text-white",staticStyle:{"cursor":"default"}},[_vm._v(" ? ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }